import {
  Navigate,
  useLocation,
  useNavigate,
  useParams,
} from 'react-router-dom';

import { getAgentDrawerConfig } from '@modules/_shared/components/visibility-drawer/configs/agentDrawerConfig';
import { VisibilityDrawer } from '@modules/_shared/components/visibility-drawer/VisibilityDrawer';
import { useCanEditTeamMember } from '@modules/_shared/hooks/useCanEditTeamMember';
import { useLocale } from '@shared/hooks/locale';

const EditTeamMemberDrawer = () => {
  const { t } = useLocale();
  const navigate = useNavigate();
  const { search } = useLocation();

  const { teamId, userId } = useParams() as {
    teamId: string;
    userId: string;
  };

  const hasPermission = useCanEditTeamMember(teamId, userId);

  const handleClose = () => navigate({ pathname: '..', search });

  if (!hasPermission) {
    return <Navigate to={{ pathname: '..', search }} replace />;
  }

  return (
    <VisibilityDrawer
      onClose={handleClose}
      entityId={userId}
      teamId={teamId}
      config={getAgentDrawerConfig(t)}
      title={t('Edit Team Member')}
    />
  );
};

export default EditTeamMemberDrawer;
